export default "__VITE_ASSET__8af259e1__"